import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
export class AppError {
  // constructor(public originalError: HttpErrorResponse) { }
  constructor(public status: number, public message: string) { }
}
